import React from "react";

import ActivityRoutesNormalXsmall from "@strava/icons/ActivityRoutesNormalXsmall";
import ActionsDownloadNormalXsmall from "@strava/icons/ActionsDownloadNormalXsmall";

import { LinkButton } from "@strava/ui/Button";
import { Checkbox } from "@strava/ui/Checkbox";
import { Label } from "@strava/ui/Label";

import { Map } from "@strava/feature-global-wasm-mre";

import I18n from "../../../utils/I18n";

import FullscreenToggle from "../FullscreenToggle/FullscreenToggle";

import styles from "./MapCustomControls.scss";

interface MapCustomControlsProps {
  createRouteURL?: string;
  gpxDownloadURL?: string;
  showMapTypeControl?: boolean;
  showFullScreenToggle?: boolean;
  showPrivacyZonesControl?: boolean;
  showPrivacyZones?: boolean;
  setShowPrivacyZones?: (show: boolean) => void;
}

export const MapCustomControls = ({
  createRouteURL,
  gpxDownloadURL,
  showMapTypeControl = false,
  showFullScreenToggle = false,
  showPrivacyZonesControl = false,
  showPrivacyZones = false,
  setShowPrivacyZones = (_: boolean | ((show: boolean) => boolean)) => {}
}: MapCustomControlsProps) => {
  return (
    <div className={styles.mapCustomControls}>
      <div className={styles.athleteControls}>
        {createRouteURL && (
          <LinkButton
            className={styles.linkButton}
            href={createRouteURL}
            data-testid="save-route-button"
          >
            <ActivityRoutesNormalXsmall />{" "}
            {I18n.t("mre.custom_control.create_route")}
          </LinkButton>
        )}
        {gpxDownloadURL && (
          <LinkButton
            className={styles.linkButton}
            href={gpxDownloadURL}
            data-testid="gpx-download-button"
          >
            <ActionsDownloadNormalXsmall />{" "}
            {I18n.t("mre.custom_control.export_gpx")}
          </LinkButton>
        )}
        {showMapTypeControl && <Map.MapTypeControl />}
        {showFullScreenToggle && <FullscreenToggle />}
      </div>
      {showPrivacyZonesControl && (
        <Label
          htmlFor="show-privacy-zones-checkbox"
          className={styles.showPrivacyZonesLabel}
        >
          {I18n.t("mre.custom_control.show_privacy_zones")}
          <Checkbox
            name="show-privacy-zones-checkbox"
            checked={showPrivacyZones}
            onChange={() => setShowPrivacyZones(!showPrivacyZones)}
          />
        </Label>
      )}
    </div>
  );
};

export default MapCustomControls;
